import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/transhumans/experiments.png")